// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sh-gm-grid__gm-item__logo-container{display:flex;align-items:center;justify-content:center;border-radius:50%;height:124px;width:124px;background-color:#fff;padding:20px;box-shadow:0 2px 2px 0 rgba(34,34,34,.08)}.sh-gm-grid__gm-item__logo{max-width:100%;max-height:100%}.sh-gm-grid__gm-item__title-container{display:flex;align-items:center;justify-content:center;height:64px}.sh-gm-grid__gm-item__subtitle-container{height:60px;margin-bottom:40px}", ""]);
// Exports
module.exports = exports;
